import { useState, useEffect } from 'react'
import { MarcaRescueLab } from './workspace/MarcaRescueLab'

const MENSAGENS_CARREGAMENTO = [
  'Inicializando simulador veicular 3D...',
  'Carregando parâmetros de deformação e corte...',
  'Mapeando zonas críticas e componentes SRS...',
  'Calibrando solver biomecânico e ocupantes...',
  'Preparando procedimentos operacionais padrão...',
  'Configurando maquete e física da cena...',
]

export function TelaCarregamento() {
  const [indiceMensagem, setIndiceMensagem] = useState(0)

  useEffect(() => {
    const intervalo = setInterval(() => {
      setIndiceMensagem((atual) => (atual + 1) % MENSAGENS_CARREGAMENTO.length)
    }, 900)
    return () => clearInterval(intervalo)
  }, [])

  return (
    <main className="tela-carregamento" role="status" aria-live="polite">
      <div className="conteudo-carregamento">
        <div className="carregamento-marca">
          <h1 className="carregamento-titulo">
            <MarcaRescueLab variante="logo" />
          </h1>
        </div>

        <div className="status-carregamento">
          <div className="spinner-delta" aria-hidden="true" />
          <p className="mensagem-rotativa" key={indiceMensagem}>
            {MENSAGENS_CARREGAMENTO[indiceMensagem]}
          </p>
        </div>

        <div className="barra-progresso-delta" aria-hidden="true">
          <div className="progresso-indeterminado" />
        </div>
      </div>
    </main>
  )
}

